import Country from './Country';
import Team from './Team';
import User from './User';

interface PlayerName {
    firstname?: string;
    lastname?: string;
}

interface PlayerMoney {
    dollar: number;
    otdollar: number;
}

interface RankingPosition {
    position?: number;
    points?: number;
}

interface PlayerRanking {
    entrylist: RankingPosition;
    championsrace: RankingPosition;
}

interface PlayerStaff {
    trainer?: number;
    teacher?: number;
    doctor?: number;
    physio?: number;
    scout?: number;
    tactican?: number;
    manager?: number;
}

interface PlayerSkill {
    average?: number;
}

export default class Player {
    public id!: number;
    public name: PlayerName = {};
    public money: PlayerMoney = { dollar: 0, otdollar: 0 };
    public avatar!: number;
    public ranking: PlayerRanking = { entrylist: {}, championsrace: {} };
    public staff: PlayerStaff = {};
    public skill: PlayerSkill = {};
    public hasDoubles!: boolean;
    public user: User | null = null;
    public country: Country = new Country();
    public team: Team = new Team();

    public static fromData(data: any): Player {
        const player = new Player();
        player.id = data.id;
        player.name = {
            firstname: data.name.firstname,
            lastname: data.name.lastname,
        };
        player.money = {
            dollar: data.money.dollar,
            otdollar: data.money.otdollar,
        };
        player.avatar = data.avatar;
        player.ranking = {
            entrylist: {
                position: data.ranking.entrylist.position,
                points: data.ranking.entrylist.points,
            },
            championsrace: {
                position: data.ranking.championsrace.position,
                points: data.ranking.championsrace.points,
            },
        };
        player.staff = {
            trainer: data.staff.trainer,
            teacher: data.staff.teacher,
            doctor: data.staff.doctor,
            physio: data.staff.physio,
            scout: data.staff.scout,
            tactican: data.staff.tactican,
            manager: data.staff.manager,
        };
        player.skill = {
            average: data.skill.average,
        };
        player.hasDoubles = data.has_doubles;

        if (data.user) {
            player.user = User.fromData(data.user.data);
        }

        if (data.country) {
            player.country = Country.fromData(data.country.data);
        }

        if (data.team) {
            player.team = Team.fromData(data.team.data);
        }

        return player;
    }

    public getFullname(): string {
        return `${this.name.firstname} ${this.name.lastname}`;
    }
}
